import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Catalogue from "@/pages/Catalogue";
import Capabilities from "@/pages/Capabilities";
import OemPrivateLabel from "@/pages/OemPrivateLabel";
import IndianWholesale from "@/pages/IndianWholesale";
import InternationalExport from "@/pages/InternationalExport";
import RequestQuote from "@/pages/RequestQuote";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <BrowserRouter>
      <SettingsProvider>
        <AuthProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Catalogue />} />
              <Route path="/womens-jeans" element={<Catalogue key="women" category="women" />} />
              <Route path="/mens-jeans" element={<Catalogue key="men" category="men" />} />
              <Route path="/kids-jeans" element={<Catalogue key="kids" category="kids" />} />
              <Route path="/capabilities" element={<Capabilities />} />
              <Route path="/oem-private-label" element={<OemPrivateLabel />} />
              <Route path="/indian-wholesale" element={<IndianWholesale />} />
              <Route path="/international-export" element={<InternationalExport />} />
              <Route path="/request-a-quote" element={<RequestQuote />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<Home />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </SettingsProvider>
    </BrowserRouter>
  );
}

export default App;
